import React, { useRef, useCallback } from 'react';
import { ModusWcModal } from '@trimble-oss/moduswebcomponents-react';
import './Modal.scss';

export type ModalBackdrop = 'default' | 'static';
export type ModalPosition = 'top' | 'center' | 'bottom';

export interface ModalProps extends React.ComponentProps<typeof ModusWcModal> {
  fullscreen?: boolean;
  backdrop?: ModalBackdrop;
  position?: ModalPosition;
  showClose?: boolean;
}

/**
 * Custom hook for managing Modus modal state and actions
 * @returns Object with modal ref, open/close functions, and Modal component
 */
export const useModusModal = () => {
  const modalRef = useRef<HTMLDialogElement>(null!);

  const openModal = useCallback(() => {
    const dialog = modalRef.current?.querySelector('dialog') as HTMLDialogElement;
    if (dialog) {
      dialog.showModal();
    }
  }, []);

  const closeModal = useCallback(() => {
    const dialog = modalRef.current?.querySelector('dialog') as HTMLDialogElement;
    if (dialog) {
      dialog.close();
    }
  }, []);

  return {
    modalRef,
    openModal,
    closeModal,
  };
};

export const Modal = React.forwardRef<any, ModalProps>((props, ref) => {
  return <ModusWcModal {...props} ref={ref} />;
});
